import { render, staticRenderFns } from "./ProfileEcBusiness.vue?vue&type=template&id=fe99a65c&scoped=true"
import script from "./ProfileEcBusiness.vue?vue&type=script&lang=js"
export * from "./ProfileEcBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe99a65c",
  null
  
)

export default component.exports